module.exports = __webpack_public_path__ + "img/kwaiMeDownload4.35d8e53.png";